// export {default as follow} from './follow';
export {default as vote} from './vote';
export {default as shopNum} from './shopnum';
export {default as delAdd} from './deladd';
export {default as editAdd} from './editadd';
export {default as addShop} from './addShop';
export {default as delShop} from './delShop';
export {default as verification} from './verification';
export {default as updateOrderAddress} from './updateOrderAddress';
export {default as visitorSave} from './visitorSave';
export {default as burialPoint} from './burialPoint';
export {default as baseRequest} from './baseRequest';
export {default as gameLogin} from './gameLogin';
export {default as burialPointOther} from './burialPointOther';
export {default as saleOrders} from './saleOrders';
export {default as register} from './register';
export {default as getWXSignature} from './getWXSignature';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/operates/index.ts